import { modifyError } from "../../../Validation/ModifyErrros";
import Api from "../../../Api";

// 🔹 Create new venue master
export const createVenueMaster = async (data) => {
  try {
    const res = await Api.post("/venue-master", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

// 🔹 Get all venue masters by vessel_id
export const getVenueMaster = async ({
  vessel_id,
  page,
  limit,
  search,
  sort,
  order,
}) => {
  try {
    console.log({ test: vessel_id });
    const res = await Api.get("/venue-master", {
      params: { vessel_id, page, limit, search, sort, order },
    });

    return res?.data?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

// 🔹 Get options for categories (if needed)
export const getCategoryOption = async (query) => {
  try {
    const res = await Api.get("/venue-master/getOption", { params: query });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

// 🔹 Get one venue master by ID (requires vessel_id)
export const getOneVenueMaster = async (id) => {
  try {
    const res = await Api.get(`/venue-master/${id}`, {});
    return res?.data || {};
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

// 🔹 Update a venue master
export const updateVenueMaster = async (id, vessel_id, data) => {
  try {
    const res = await Api.put(`/venue-master/${id}`, data, {
      params: { vessel_id },
    });
    return res?.data || {};
  } catch (e) {
    return { error: "Failed to Update" };
  }
};

// 🔹 Delete a venue master
export const deleteVenueMaster = async (id, vessel_id) => {
  try {
    const res = await Api.delete(`/venue-master/${id}`, {
      params: { vessel_id },
    });
    return res?.data || {};
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

// 🔹 Toggle active status
export const toggleVenueStatus = async (id, vessel_id) => {
  try {
    const res = await Api.patch(
      `/venue-master/update-status/${id}`,
      {}, // empty body since you’re not sending data in the body
      { params: { vessel_id } } // query params go here
    );
    return res?.data || {};
  } catch (e) {
    return { error: "Failed to update status" };
  }
};

// 🔹 Update positions (relocate)
export const updatePosition = async (banners, query) => {
  try {
    const res = await Api.patch("/venue-master/relocate-position", banners, {
      params: query,
    });
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};

export const fetchDeckList = async (vessel_id) => {
  try {
    const res = await Api.get(`/venue-master/deck-number-list/${vessel_id}`);

    return res?.data?.data || [];
  } catch (e) {
    return { error: "Failed to fetch decklist" };
  }
};
